import {
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { asList2ho2pewtsfvv as asList } from './_ArraysJs.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../comparisons/Comparisons.mjs';
import {
  filterNotNullhujglslymx1l as filterNotNull,
  contains1tccixv8iwdcq as contains,
} from './_Arrays.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../js/arrays.mjs';
import {
  toMutableListoiy7juhbnlr7 as toMutableList,
  shuffle28202iiliqd4i as shuffle,
} from './_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lastIndex(_this__u8e3s4) {
  return _this__u8e3s4.q2() - 1 | 0;
}
function throwIndexOverflow() {
  throw ArithmeticException().fe('Index overflow has happened.');
}
function collectionToArrayCommonImpl(collection) {
  if (collection.n1()) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.arrayOfNulls' call
  var size = collection.q2();
  var destination = Array(size);
  var iterator = collection.p1();
  var index = 0;
  while (iterator.q1()) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    destination[_unary__edvuaz] = iterator.r1();
  }
  return destination;
}
function emptyList() {
  return EmptyList_instance;
}
function listOf_0(elements) {
  return elements.length > 0 ? asList(elements) : emptyList();
}
function get_indices(_this__u8e3s4) {
  return numberRangeToNumber(0, _this__u8e3s4.q2() - 1 | 0);
}
function mutableListOf(elements) {
  var tmp;
  if (elements.length === 0) {
    tmp = ArrayList().p2();
  } else {
    // Inline function 'kotlin.collections.asArrayList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ArrayList().g6(elements);
  }
  return tmp;
}
function binarySearch(_this__u8e3s4, element, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.q2() : toIndex;
  rangeCheck(_this__u8e3s4.q2(), fromIndex, toIndex);
  var low = fromIndex;
  var high = toIndex - 1 | 0;
  while (low <= high) {
    var mid = (low + high | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4.r2(mid);
    var cmp = compareValues(midVal, element);
    if (cmp < 0)
      low = mid + 1 | 0;
    else if (cmp > 0)
      high = mid - 1 | 0;
    else
      return mid;
  }
  return -(low + 1 | 0) | 0;
}
function listOfNotNull(elements) {
  return filterNotNull(elements);
}
var EmptyIteratorClass;
function EmptyIterator() {
  if (EmptyIteratorClass === VOID) {
    class $ {
      q1() {
        return false;
      }
      a7() {
        return false;
      }
      r1() {
        throw NoSuchElementException().t6();
      }
      b7() {
        throw NoSuchElementException().t6();
      }
    }
    initMetadataForObject($, 'EmptyIterator');
    EmptyIteratorClass = $;
  }
  return EmptyIteratorClass;
}
var EmptyIterator_instance;
function EmptyIterator_getInstance() {
  return EmptyIterator_instance;
}
function asCollection(_this__u8e3s4, isVarargs) {
  isVarargs = isVarargs === VOID ? false : isVarargs;
  return new (ArrayAsCollection())(_this__u8e3s4, isVarargs);
}
function optimizeReadOnlyList(_this__u8e3s4) {
  switch (_this__u8e3s4.q2()) {
    case 0:
      return emptyList();
    case 1:
      return listOf(_this__u8e3s4.r2(0));
    default:
      return _this__u8e3s4;
  }
}
function throwCountOverflow() {
  throw ArithmeticException().fe('Count overflow has happened.');
}
var EmptyListClass;
function EmptyList() {
  if (EmptyListClass === VOID) {
    class $ {
      constructor() {
        this.zj_1 = -7390468764508069838n;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtList()) : false) {
          tmp = other.n1();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 1;
      }
      toString() {
        return '[]';
      }
      q2() {
        return 0;
      }
      n1() {
        return true;
      }
      ak(element) {
        return false;
      }
      t2(element) {
        if (!false)
          return false;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.ak(tmp);
      }
      bk(elements) {
        return elements.n1();
      }
      q4(elements) {
        return this.bk(elements);
      }
      r2(index) {
        throw IndexOutOfBoundsException().i3("Empty list doesn't contain element at index " + index + '.');
      }
      ck(element) {
        return -1;
      }
      r4(element) {
        if (!false)
          return -1;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.ck(tmp);
      }
      p1() {
        return EmptyIterator_instance;
      }
      v2(index) {
        if (!(index === 0))
          throw IndexOutOfBoundsException().i3('Index: ' + index);
        return EmptyIterator_instance;
      }
      b3(fromIndex, toIndex) {
        if (fromIndex === 0 && toIndex === 0)
          return this;
        throw IndexOutOfBoundsException().i3('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
      }
    }
    initMetadataForObject($, 'EmptyList', VOID, VOID, [KtList(), RandomAccess()]);
    EmptyListClass = $;
  }
  return EmptyListClass;
}
var EmptyList_instance;
function EmptyList_getInstance() {
  return EmptyList_instance;
}
function rangeCheck(size, fromIndex, toIndex) {
  if (fromIndex > toIndex)
    throw IllegalArgumentException().o2('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
  else if (fromIndex < 0)
    throw IndexOutOfBoundsException().i3('fromIndex (' + fromIndex + ') is less than zero.');
  else if (toIndex > size)
    throw IndexOutOfBoundsException().i3('toIndex (' + toIndex + ') is greater than size (' + size + ').');
}
var ArrayAsCollectionClass;
function ArrayAsCollection() {
  if (ArrayAsCollectionClass === VOID) {
    class $ {
      constructor(values, isVarargs) {
        this.dk_1 = values;
        this.ek_1 = isVarargs;
      }
      q2() {
        return this.dk_1.length;
      }
      n1() {
        // Inline function 'kotlin.collections.isEmpty' call
        return this.dk_1.length === 0;
      }
      fk(element) {
        return contains(this.dk_1, element);
      }
      t2(element) {
        if (!true)
          return false;
        return this.fk(element);
      }
      p1() {
        return arrayIterator(this.dk_1);
      }
    }
    initMetadataForClass($, 'ArrayAsCollection', VOID, VOID, [Collection()]);
    ArrayAsCollectionClass = $;
  }
  return ArrayAsCollectionClass;
}
function shuffled(_this__u8e3s4, random) {
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableList(_this__u8e3s4);
  shuffle(this_0, random);
  return this_0;
}
//region block: init
EmptyIterator_instance = new (EmptyIterator())();
EmptyList_instance = new (EmptyList())();
//endregion
//region block: exports
export {
  EmptyIterator_instance as EmptyIterator_instanceqrxhm096rah7,
  EmptyList_instance as EmptyList_instance37yll8kifu7ar,
  asCollection as asCollection2jt8ak1h50iom,
  binarySearch as binarySearch1nmlzx9onl5pm,
  collectionToArrayCommonImpl as collectionToArrayCommonImplq0mfhcp9jn08,
  emptyList as emptyList1g2z5xcrvp2zy,
  get_indices as get_indices3txodfl5wuu5j,
  get_lastIndex as get_lastIndex1yw0x4k50k51w,
  listOfNotNull as listOfNotNull2woi2boe01ub4,
  listOf_0 as listOf1jh22dvmctj1r,
  mutableListOf as mutableListOf6oorvk2mtdmp,
  optimizeReadOnlyList as optimizeReadOnlyList2kolyxeo5m6k3,
  shuffled as shuffled3grcsjfy8dw80,
  throwCountOverflow as throwCountOverflow18of2v929seka,
  throwIndexOverflow as throwIndexOverflow28kwzhaoae5ib,
};
//endregion

//# sourceMappingURL=CollectionsKt.mjs.map
